import { observer } from 'mobx-react-lite';
import { useContext, useEffect, useState } from 'react';
import { StoreContext } from '../../stores';
import { useTranslation } from 'react-i18next';

import classes from './Keyword.module.css';
import DynamicScrollbar from '../../components/DynamicScrollbar/DynamicScrollbar';
import Loader from '../../components/Loader/Loader';
import { KeywordItemContent } from './Keyword/KeywordItemContent';
import { useParams } from 'react-router-dom';

function Keyword() {
  const params = useParams() as {[id: string]: string};
  const { uiStore } = useContext(StoreContext),
    { t } = useTranslation();
  const keywordId = params.id;
  const loading = false;
  const keyword = {};
  const [scrollEnabled] = useState(true);

  useEffect(() => {
    uiStore.setTitle(t('Keyword'));
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`${classes.container} ${loading ? classes.center : ''}`}>
      {loading && <Loader />}
      {loading === false && keyword && (
        <DynamicScrollbar
          contentClassName={classes.body}
          noScrollY={!scrollEnabled}
        >
          <KeywordItemContent keywordId={keywordId} />
          { /* <ActionPanels action={action} onModalOpened={onModalOpened} /> */}
        </DynamicScrollbar>
      )}
    </div>
  );
}

export default observer(Keyword);
